<span class="order-receipt-product-description">{{ description }}</span>
<box-quantity class="order-receipt-product-quantity" [dense]="true" [disabled]="true" [quantity]="quantity"></box-quantity>
<span class="order-receipt-product-price ods-typography-body-s-bold">{{ price }}</span>